import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROLE_LEVEL } from '../utils/constants';

export function ProtectedRoute({ children, minRole }) {
  const { isAuthenticated, isLoading, user, impersonatingRole } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen" data-testid="auth-loading">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-[var(--lumyn-content)] border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (minRole && user) {
    const effectiveRole = impersonatingRole || user.role;
    const userLevel = ROLE_LEVEL[effectiveRole] || 0;
    const required = ROLE_LEVEL[minRole] || 99;
    if (userLevel < required) {
      // During impersonation, redirect to the role-aware landing ('/' →
      // HomeRedirect) instead of showing 403
      if (impersonatingRole && location.pathname !== '/') {
        return <Navigate to="/" replace />;
      }
      return (
        <div className="flex items-center justify-center h-[60vh]" data-testid="forbidden-page">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-destructive">403</h1>
            <p className="text-muted-foreground mt-2">You don't have permission to access this page.</p>
          </div>
        </div>
      );
    }
  }

  return children;
}
